// extracted by mini-css-extract-plugin
export default {"body":"order-details_body__u0NKK","number":"order-details_number__ihZuV"};